import { Grid } from 'antd'

// Tablet is antd `md` through `lg` (768–1199): iPad portrait and landscape both
// land inside it, while laptops at 1200 and up keep the full desktop layout.
// Mirrors useIsMobile in reading resolved breakpoints only, so the unresolved
// initial `{}` counts as desktop rather than flashing a narrower layout.
export default function useIsTablet() {
  const screens = Grid.useBreakpoint()
  return screens.md === true && screens.xl !== true
}
